export default __webpack_public_path__ + "static/seo-img-1fa334b5fb91ad5e571048eb4dbc429d.jpg";